import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const pillRemoveFn = /* @__PURE__ */ createRecipe('pill-remove', {}, [])

const pillRemoveVariantMap = {
  "color": [
    "danger"
  ]
}

const pillRemoveVariantKeys = Object.keys(pillRemoveVariantMap)

export const pillRemove = /* @__PURE__ */ Object.assign(memo(pillRemoveFn.recipeFn), {
  __recipe__: true,
  __name__: 'pillRemove',
  __getCompoundVariantCss__: pillRemoveFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: pillRemoveVariantKeys,
  variantMap: pillRemoveVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, pillRemoveVariantKeys)
  },
  getVariantProps: pillRemoveFn.getVariantProps,
})